export default () => {
    return (
        <div className="fixed z-0 bottom-0 left-0 mb-4 ml-4 max-w-[100vw] xs:hidden sm:hidden">
            <div className="text-gray-100 text-xl font-semibold py-2 px-4">
                <div>
                    <a href="http://www.google.com/search?q=We+Are+your+physical+and+mental+personal+training">
                        Op basis van{" "}
                        <span className="text-we-are-yellow">
                            200 Google beoordelingen
                        </span>
                    </a>
                </div>
                {[...Array(5)].map((x, i) => (
                    <div key={i} className="inline-block">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="h-8 w-8 text-we-are-yellow"
                        >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                    </div>
                ))}
            </div>
        </div>
    );
};
